"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HitList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Tile_1 = require("Views/Shared/Components/Tile");
const index_1 = require("./index");
const context_1 = require("../context");
const defaultImageTypeMap = {
    [Tile_1.TileTypeEnum.Page]: false,
    [Tile_1.TileTypeEnum.Product]: 'default',
    [Tile_1.TileTypeEnum.Download]: 'logo',
    [Tile_1.TileTypeEnum.Document]: false,
};
const HitList = () => {
    var _a;
    const { tiles, isHitsLoading, selectedTab, totalPages, resultCount, currentPage, dictionary } = (0, context_1.useSearchResultContext)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isHitsLoading ? ((0, jsx_runtime_1.jsx)(index_1.ContentLoading, { className: "absolute" })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Tile_1.TileList, { items: tiles, tileType: Tile_1.TileTypeEnum.SearchResults, tileShape: Tile_1.TileShapeEnum.WideSmall, defaultImageType: (_a = defaultImageTypeMap[selectedTab.tileType]) !== null && _a !== void 0 ? _a : false, totalItems: resultCount, currentPage: currentPage, dictionary: dictionary }), totalPages > 1 && (0, jsx_runtime_1.jsx)(index_1.PaginationPanel, {})] })) }));
};
exports.HitList = HitList;
